import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import './advices.css'

const Advices = (props) => {
  return (
    <div className="advices-container">
      <Helmet>
        <title>Advices - Hackathon</title>
        <meta property="og:title" content="Advices - Hackathon" />
      </Helmet>
      <div className="advices-container01">
        <span className="advices-text">You are not alone!</span>
        <span className="advices-text01">
          If you start to feel lonely, try to do this:
        </span>
      </div>
      <div className="advices-container02">
        <div className="advices-container03">
          <img
            alt="image"
            src="/playground_assets/blueberry-200h.png"
            className="advices-image"
          />
          <div className="advices-container04">
            <h2 className="advices-text02">Talk with a friend</h2>
            <span className="advices-text02">
              <span>Use Whatsapp, Line, SMS or whatever you prefer. </span>
              <br></br>
            </span>
          </div>
        </div>
        <div className="advices-container03">
          <img
            alt="image"
            src="/playground_assets/pineapple%20%5B1%5D-200h.png"
            className="advices-image1"
          />
          <div className="advices-container04">
            <h2 className="advices-text02">Look for new activities</h2>
            <span className="advices-text03">
              <span>
                Think in things you always want to do: dance, write, karate,
                learn a foreing lenguage... 
              </span>
              <span>There are a lot of posibilities near to you!</span>
              <br></br>
              <span>
                Start a new activities and find friends with the same insteres
              </span>
            </span>
          </div>
        </div>
        <div className="advices-container03">
          <img
            alt="image"
            src="/playground_assets/cool--200h.png"
            className="advices-image2"
          />
          <div className="advices-container04">
            <h2 className="advices-text02">Talk with an expert</h2>
            <span className="advices-text03">
              <span>
                Remember, you are not alone. There are a lot of professionals in
                mental health who can help you
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="advices-container09">
        <span className="advices-text17">
          Refusing to receive help is refusing to be well.
        </span>
      </div>
      <Link to="/" className="nav-navlink" >
        <button className="button advices-button">Go Back</button>
      </Link>
    </div>
  )
}

export default Advices
